import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { useChatEnabled } from '../../context/FeatureFlagContext';
import './MobileHeader.css';

const MobileHeader = ({
  title,
  onMenuClick,
  onTitleClick,
  activeView,
  onViewChange,
  onPrimaryAction,
  onSecondaryAction,
  userInfo,
  onUserClick,
}) => {
  const showSwitcher = typeof onViewChange === 'function';
  const chatEnabled = useChatEnabled();

  return (
    <div className="mobile-header">
      <button
        type="button"
        className="mobile-header-icon"
        onClick={onMenuClick}
        aria-label="Open menu"
      >
        <MenuIcon fontSize="small" />
      </button>
      <button
        type="button"
        className="mobile-header-title"
        onClick={onTitleClick}
        aria-label={title ? `Current view: ${title}` : 'Current view'}
      >
        <span className="mobile-header-title-text">{title || 'NanoTrader'}</span>
        <span className="mobile-header-title-caret" aria-hidden="true">
          <KeyboardArrowDownIcon fontSize="small" />
        </span>
      </button>
      {showSwitcher && (
        <div className="mobile-header-switcher" role="tablist" aria-label="View switcher">
          <button
            type="button"
            className={`mobile-header-tab ${activeView === 'graph' ? 'active' : ''}`}
            onClick={() => onViewChange('graph')}
            role="tab"
            aria-selected={activeView === 'graph'}
          >
            <ShowChartIcon className="mobile-header-tab-icon" />
            <span>Chart</span>
          </button>

          {chatEnabled && (
            <button
              type="button"
              className={`mobile-header-tab ${activeView === 'chat' ? 'active' : ''}`}
              onClick={() => onViewChange('chat')}
              role="tab"
              aria-selected={activeView === 'chat'}
            >
              <ChatBubbleOutlineIcon className="mobile-header-tab-icon" />
              <span>Chat</span>
            </button>
          )}

          <button
            type="button"
            className={`mobile-header-tab ${activeView === 'validate' ? 'active' : ''}`}
            onClick={() => onViewChange('validate')}
            role="tab"
            aria-selected={activeView === 'validate'}
          >
            <FactCheckOutlinedIcon className="mobile-header-tab-icon" />
            <span>Gate</span>
          </button>
        </div>
      )}
      <div className="mobile-header-right">
        {(onPrimaryAction || onSecondaryAction) && (
          <div className="mobile-header-actions">
            {onPrimaryAction && (
              <button
                type="button"
                className="mobile-header-icon"
                onClick={onPrimaryAction}
                aria-label="Primary action"
              >
                <EditOutlinedIcon fontSize="small" />
              </button>
            )}
            {onSecondaryAction && (
              <button
                type="button"
                className="mobile-header-icon"
                onClick={onSecondaryAction}
                aria-label="More options"
              >
                <MoreHorizIcon fontSize="small" />
              </button>
            )}
          </div>
        )}
        {onUserClick && (
          <button
            type="button"
            className="mobile-header-avatar"
            onClick={onUserClick}
            aria-label="Open account menu"
          >
            {userInfo?.picture ? (
              <img src={userInfo.picture} alt="User" />
            ) : (
              <span>{userInfo?.username?.[0]?.toUpperCase() || 'U'}</span>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default MobileHeader;
